import { FormField } from '@alice-financial/alice-sdk'

// simple parser for form fields to extract the answer for a given questionId
export const fieldAnswer = <AssertedAnswerType extends string = string>(
  formFields: Array<FormField> | undefined,
  questionId: string
): AssertedAnswerType | undefined => {
  const field = formFields?.find((field) => field.questionId === questionId)
  return field?.answer as AssertedAnswerType | undefined
}
